import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const deleteComment = async (commentId: number) => {
	const response = await cmsClient.delete(`/comments/${commentId}/`);
	return response.data;
};

const useDeleteComment = () => {
	const queryClient = useQueryClient();

	return useMutation(deleteComment, {
		onSettled: () => {
			queryClient.invalidateQueries(["post-comments"]);
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useDeleteComment;
